$.fn.extend({
    insertAtCaret: function(value) {
        this.each(function() {
            if (document.selection) {
                this.focus();
                let sel = document.selection.createRange();
                sel.text = value;
                this.focus();
            } else if (this.selectionStart || this.selectionStart == '0') {
                let startPos = this.selectionStart;
                let endPos = this.selectionEnd;
                let scrollTop = this.scrollTop;
                this.value = this.value.substring(0, startPos) +
                value + this.value.substring(endPos,this.value.length);
                this.focus();
                this.selectionStart = startPos + value.length;
                this.selectionEnd = startPos + value.length;
                this.scrollTop = scrollTop;
            } else {
                this.value += value;
                this.focus();
            }
        });
        return this;
    }
});
